import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ms_admin_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(r => setEmail(r.data.email))
      .catch(() => localStorage.removeItem("ms_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (e, p) => {
    const r = await api.post("/auth/login", { email: e, password: p });
    localStorage.setItem("ms_admin_token", r.data.token);
    setEmail(r.data.email);
    return r.data;
  };
  const logout = () => { localStorage.removeItem("ms_admin_token"); setEmail(null); };

  return <AuthContext.Provider value={{ email, loading, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
